import React from "react";


import { Col, Row } from "react-bootstrap";


import "./index.scss";


type SectionContainerHeaderComponentProps = {
    headerText?: string;
    descriptionText?: string;
    className?: string;
};


export const SectionContainerHeaderComponent:React.FC<SectionContainerHeaderComponentProps> = ({
    headerText, descriptionText, className
}) => {

    if (!headerText && !descriptionText) {
        return null;
    }

    return (
        <Col xs={12} className={`section-container__header ${className}__header`}>
            <Row>

                {headerText &&
                <Col xs={12} className={`section-container__header__head ${className}__header__head`}>
                    <span>{headerText}</span>
                </Col>
                }

                {descriptionText &&
                <Col xs={12} className={`section-container__header__description ${className}__header__description`}>
                    <span>{descriptionText}</span>
                </Col>
                }

            </Row>
        </Col>
    );

};


export default SectionContainerHeaderComponent;
